/**
 * Simple translation hook for RegisterForm
 * Returns a function that can access nested translation keys
 */
export const useTranslation = () => {
  const t = (...keys) => {
    // Simple translation map - you can expand this later
    const translations = {
      register: {
        form: {
          title: 'Request a Demo',
          description: 'Fill out the form below to request a demo of CargoFlow.',
          submit: 'Submit Request',
          submitting: 'Submitting...',
          success: 'Thank you! Your request has been submitted successfully. Redirecting to demo...',
          fields: {
            company: 'Company Name',
            email: 'Email Address',
            expectedDuas: 'Expected Number of DUAs',
            expectedDuasHelp: 'This helps us understand your usage needs and provide better service recommendations.'
          },
          errors: {
            companyRequired: 'Company name is required',
            emailRequired: 'Email address is required',
            validEmail: 'Please enter a valid email address',
            expectedDuasRequired: 'Expected number of DUAs is required',
            fillAllFields: 'Please fill in all required fields',
            generalError: 'An error occurred. Please try again later.'
          }
        }
      }
    };

    // Navigate through nested object
    let value = translations;
    for (const key of keys) {
      if (value && typeof value === 'object' && key in value) {
        value = value[key];
      } else {
        // Return the last key if translation not found
        return keys[keys.length - 1];
      }
    }
    
    return typeof value === 'string' ? value : keys[keys.length - 1];
  };

  return { t };
};

